var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoggedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C7.83266 0 0 7.83266 0 17.5C0 27.1673 7.83266 35 17.5 35C27.1673 35 35 27.1673 35 17.5C35 7.83266 27.1673 0 17.5 0ZM17.5 6.77419C20.9294 6.77419 23.7097 9.55444 23.7097 12.9839C23.7097 16.4133 20.9294 19.1935 17.5 19.1935C14.0706 19.1935 11.2903 16.4133 11.2903 12.9839C11.2903 9.55444 14.0706 6.77419 17.5 6.77419ZM17.5 31.0484C13.3579 31.0484 9.64617 29.1714 7.1623 26.2359C8.48891 23.7379 11.0857 22.0161 14.1129 22.0161C14.2823 22.0161 14.4516 22.0444 14.6139 22.0938C15.5313 22.3901 16.4909 22.5806 17.5 22.5806C18.5091 22.5806 19.4758 22.3901 20.3861 22.0938C20.5484 22.0444 20.7177 22.0161 20.8871 22.0161C23.9143 22.0161 26.5111 23.7379 27.8377 26.2359C25.3538 29.1714 21.6421 31.0484 17.5 31.0484Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoggedin);
export default __webpack_public_path__ + "static/media/loggedin.6a03118b13a86c650c2f382bc45d8863.svg";
export { ForwardRef as ReactComponent };